var SJ = SJ || {};
var __ = __ || function(str) {return str;};

SJ.Surveys = SJ.Surveys || {

    surveyId: null,
    ERROR_MESSAGE: "An error occurred, please reload the page and try again.",

    init: function () {
        var self = this;

        this.surveyId = $('#sj-content').attr('data-survey');

        $(document).on('mousedown', function(event) {

            // Detect click on scroll
            if ($('html').is(event.target)) {
                return;
            }

            if ( ! (
                $(event.target).hasClass('survey-element-placeholder') ||
                $(event.target).hasClass('sj-survey-move')
            ) ) {
                if ( ! $(event.target).parent('.survey-element-placeholder').length ) {
                    $('.survey-element-placeholder').remove();
                }
            }
        });

        $('body').on('click', '._sj-select-text', function() {
            self.selectText($(this).attr('id'));
        });
    },

    selectText: function (element) {
        var doc = document,
            text = doc.getElementById(element),
            range,
            selection;

        if ( typeof doc.body.createTextRange === 'function' ) {
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if ( typeof window.getSelection === 'function' ) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    },

    forceQuestionTypeChangeEvent : function() {
        $('#_sj-question-type').change();
    },

    Form: {

        init: function() {
            var self = this;

            //Attach Events
            $('body')
                .on('click', '#_sj-add-detail', self.addDetail)
                .on('click', '#_sj-add-sub-detail', self.addSubDetail)
                .on('click', '._sj-remove-detail', self.removeDetail)
                .on('change', '#_sj-question-type', self.switchQuestionType)
                .on('click', '.sj-survey-move', self.moveQuestion)
                .on('click', '.survey-element-placeholder', self.performMoveQuestion)
                .on('change', '#_sj-survey-option-texttype', self.textTypeToggleMultipleMode);

                $('.js-survey-question')
                    .on('change', function() {
                        self.showOther($(this));
                    })
                    .trigger('change');
        },

        showOther: function($selector) {
            var question = $selector.data('question'),
                otherQuestionNode = $('#survey_other_' + question);
            if ( $selector.val() === 'other' ) {
                var type = $selector.attr('type'),
                    checked = $selector.is(':checked');

                if (
                    (type !== 'checkbox' && type !== 'radio') ||
                    ((type === 'checkbox' || type  === 'radio') && checked)
                )
                {
                    otherQuestionNode.removeClass('bs3-hide');
                    return;
                }
            }

            otherQuestionNode.addClass('bs3-hide');
        },

        renderDetailView: function (body, key) {
            return  '<div class="_sj-line-detail" data-key="'+key+'">'
                + '<div class="bs3-form-group">'
                + '<div class="bs3-col-sm-offset-2 bs3-col-sm-10">'
                + '<div class="bs3-input-group">'
                + body
                + '</div>'
                + '</div>'
                + '</div>'
                + '</div>';
        },

        addDetail: function() {
            var detailsAreaNode = $('#_sj-details-area'),
                key = detailsAreaNode
                .children()
                .last()
                .attr('data-key');
            if ( typeof key === 'undefined' || isNaN(key) ) {
                key = 0;
            } else {
                key++;
            }
            var html = SJ.Surveys.Form.renderDetailView(
                '<input type="text" required="required" value="" placeholder="" name="details['+key+']" class="bs3-form-control">' +
                '<span class="bs3-input-group-addon"><a class="_sj-remove-detail prevent-default" href="#">' + __('Remove') + '</a></span>',
                key
            );
            detailsAreaNode.append(html);
        },

        addSubDetail: function() {
            var subDetailsNode = $('#_sj-sub-details-area'),
                key = subDetailsNode
                .children()
                .last()
                .attr('data-key');
            if ( typeof key === 'undefined' || isNaN(key) ) {
                key = 0;
            } else {
                key++;
            }
            var html = SJ.Surveys.Form.renderDetailView(
                '<input type="text" required="required" value="" placeholder="" name="sub-details['+key+']" class="bs3-form-control">' +
                '<span class="bs3-input-group-addon"><a class="_sj-remove-detail prevent-default" href="#">' + __('Remove') + '</a></span>',
                key
            );
            subDetailsNode.append(html);
        },

        removeDetail: function() {
            $(this).parents('div._sj-line-detail').remove();
        },

        switchQuestionType: function() {
            var optionOtherNode = $('._sj-survey-option-other'),
                optionOtherRequiredNode = $('._sj-survey-option-required'),
                optionMultiSelectionNode = $('._sj-survey-option-multipleselection'),
                optionTextBoxNode = $('._sj-survey-option-textbox'),
                optionTextTypeNode = $("#_sj-survey-option-texttype"),
                detailsAreaParentNode = $('#_sj-details-area').parent(),
                subDetailsAreaParentNode = $('#_sj-sub-details-area').parent();

            $('._sj-survey-setup').addClass('bs3-hide');

            switch ($("#_sj-question-type option:selected").val()) {

                case '4': // Dropdown
                    detailsAreaParentNode.removeClass('bs3-hide');
                    optionOtherNode.removeClass('bs3-hide');
                    optionOtherRequiredNode.removeClass('bs3-hide');

                    break;
                case '3': // Date Picker
                    optionOtherRequiredNode.removeClass('bs3-hide');
                    break;
                case '1': // Multiple choice
                    detailsAreaParentNode.removeClass('bs3-hide');
                    optionOtherNode.removeClass('bs3-hide');
                    optionMultiSelectionNode.removeClass('bs3-hide');
                    optionOtherRequiredNode.removeClass('bs3-hide');

                    break;
                case '5': // Matrix
                    detailsAreaParentNode.removeClass('bs3-hide');
                    subDetailsAreaParentNode.removeClass('bs3-hide');
                    optionOtherRequiredNode.removeClass('bs3-hide');

                    break;
                case '0': // Paragraph text block
                    // $('._sj-survey-option-required').addClass('bs3-hide');

                    break;
                case '2': // Text boxes
                    optionTextBoxNode.removeClass('bs3-hide');
                    optionOtherRequiredNode.removeClass('bs3-hide');
                    if ( optionTextTypeNode.val() === 'multiple' ) {
                        detailsAreaParentNode.removeClass('bs3-hide');
                    }
                case '6': // Boolean
                    optionOtherRequiredNode.removeClass('bs3-hide');
                    break;
            }
        },

        moveQuestion: function() {
            $('.survey-element-placeholder').remove();
            var element = $(this).parents('div.survey-question-element'),
                element_id =  parseInt(element.attr('id').match(/^question_([0-9]+)/)[1], 10),
                placeholder = '<div class="bs3-btn bs3-btn-default bs3-btn-block bs3-btn-xs survey-element-placeholder prevent-default cms-element-placeholder placeholder-id-' + element_id + '">' + __('Move __name__ here', {name: name.toLowerCase()}) + '</div>';

            // get parent element
            $('.survey-question-element')
                .after(placeholder)
                .first()
                .before(placeholder);

            element.prev().remove();
            element.next().remove();
        },

        performMoveQuestion: function() {
            // Get data. do something.
            var placeholder = $(this),
                id = placeholder.attr('class').match(/placeholder-id-([0-9]+)/)[1],
                count = placeholder.prevAll('.survey-question-element').length;

            $.post(
                SJ.Core.url('/questions/move/' + id),
                {
                    position: count,
                    id: id,
                    survey_id: SJ.Surveys.surveyId
                },
                function () {
                },
                'json'
            ).done(function( data ) {
                if (data.status != 1) {
                    alert( SJ.Surveys.ERROR_MESSAGE );
                    return;
                }

                var element = $('#question_'+id);
                placeholder.after(element);

                $('.survey-element-placeholder').remove();
            }).fail(function() {
                alert( SJ.Surveys.ERROR_MESSAGE );
            });
        },

        textTypeToggleMultipleMode: function() {
            if ($("#_sj-survey-option-texttype").val() === 'multiple') {
                $('#_sj-details-area').parent().removeClass('bs3-hide');
            } else {
                $('#_sj-details-area').parent().addClass('bs3-hide');
            }
        }
    },

    //----------------------------------------------------------------------------------------------------------------------------------------------
    Reports: {
        flag_wait : 1,
        init: function() {
            var self = this;
            if ( $('#report_container').length ){
               self.setLoad();
               self.setResetFilters();
            }
        },
        setLoad: function() {
            var self = this;
            $(document).on('change', '._report_filters', function() {
                self.load($(this).attr("id"));
            });
        },
        load: function(changeId) {
            if ( this.flag_wait ) {
                var data = {},
                    groupsNode = $('#groups'),
                    groupTypesNode = $('#group_types');

                this.flag_wait = 0;

                if ( changeId === 'group_types' && groupTypesNode.val() != 0 ) {
                    groupsNode.val(0);
                }

                data.change_id = changeId;
                data.report_id = $('#report_id').val();
                data.period_id = $('#period_id').val();
                data.period_id_from = $('#period_id_from').val();
                data.period_id_to = $('#period_id_to').val();
                data.assigntype = $('#assigntype').val();
                data.reasons = $('#reasons').val();
                data.group_types = groupTypesNode.val();
                data.groups = groupsNode.val();

                if ( data.report_id ) {
                   SJ.Charts.Init.clearData();
                }

                $('#report_container')
                    .prepend('<div class="ajax-container-loading"><i class="fa fa-spinner fa-spin"></i></div>')
                    .load('/reports/report', data, function() {
                        $('#report_container').find('.ajax-container-loading').remove();
                        SJ.Charts.Init.executeFromData();
                        SJ.Core.Datepicker.init();
                        document.getElementById("report_id").scrollIntoView();
                        SJ.Surveys.Reports.flag_wait = 1;
                    });
            }
        },
        setResetFilters: function() {
            $(document).on('click', '#reset_report_filetrs', function() {
                SJ.Surveys.Reports.resetFilters();
            });
        },
        resetFilters : function(){
            $('._report_filters').each(function() {
                if ( $(this).attr('id') !== 'report_id' ) {
                    $(this).val(0);
                }
            });
            SJ.Surveys.Reports.load('reset_report_fileters');
        }
    }
    //----------------------------------------------------------------------------------------------------------------------------------------------
};

// Init all needed references
$(document).ready(function() {
    SJ.Surveys.init();
    SJ.Surveys.Reports.init();
    SJ.Surveys.Form.init();
});
